import { render, staticRenderFns } from "./DashboardFilters.vue?vue&type=template&id=da2bc8a0&scoped=true"
import script from "./DashboardFilters.vue?vue&type=script&lang=js"
export * from "./DashboardFilters.vue?vue&type=script&lang=js"
import style0 from "./DashboardFilters.vue?vue&type=style&index=0&id=da2bc8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2bc8a0",
  null
  
)

export default component.exports